import { createClient } from "@supabase/supabase-js";

// Snapshot the auth type out of the URL hash BEFORE createClient runs, because
// detectSessionInUrl consumes the session and wipes the hash. /welcome needs to
// know it was reached from an invite link even after that has happened —
// without this it could bounce a brand-new hire straight to the dashboard with
// no password ever set, and they'd be locked out on their next sign-in.
export const initialAuthType: string | null = (() => {
  if (typeof window === "undefined") return null;
  const h = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
  const type = new URLSearchParams(h).get("type");
  return type || new URLSearchParams(window.location.search).get("type");
})();

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // eslint-disable-next-line no-console
  console.error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY env vars");
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // iOS home-screen (standalone) PWAs can hang forever inside navigator.locks,
    // which supabase-js uses to coordinate token refresh — that left the app
    // stuck on the "Loading…" splash and never booting. Use a no-op lock so
    // getSession()/refresh always resolve. We don't run multiple tabs that need
    // cross-tab refresh coordination, so nothing is lost.
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});
